import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	Header,
	Title,
	Subtitle,
	Button,
	Input,
	InputWrapper,
	GroupInput,
	Form,
} from './signupFormStyles';

import Spinner from 'core/components/Spinner';

class SignupForm extends Component {
	render() {
		const {
			formHandler,
			email,
			inputChangeHandler,
			inputBlurHandler,
			inputFocusHandler,
			emailInvalid,
			loading,
			submitText,
			title,
			subtitle,
		} = this.props;
		const invalidInputs = emailInvalid;
		const disabled = invalidInputs || loading;

		return (
			<Form action="/handle-subscribe/" onSubmit={formHandler} target="_top">
				<Header>
					<Title>{title}</Title>
					<Subtitle>{subtitle}</Subtitle>
				</Header>
				<GroupInput>
					<InputWrapper>
						<Input
							id="signupWidgetEmail"
							placeholder="Email Address"
							type="email"
							name="email"
							value={email}
							onChange={inputChangeHandler}
							onFocus={inputFocusHandler}
							onBlur={inputBlurHandler}
							required
							focusColor={'lavender'}
							errorMsg={emailInvalid ? 'Invalid email' : undefined}
						/>
					</InputWrapper>
					<Button type="submit" disabled={disabled}>
						{loading ? <Spinner /> : submitText}
					</Button>
				</GroupInput>
			</Form>
		);
	}

	static propTypes = {
		title: PropTypes.string,
		subtitle: PropTypes.string,
		submitText: PropTypes.string,
		email: PropTypes.string,
		emailInvalid: PropTypes.bool,
		inputChangeHandler: PropTypes.func,
		inputBlurHandler: PropTypes.func,
		inputFocusHandler: PropTypes.func,
		formHandler: PropTypes.func,
		loading: PropTypes.bool,
	}
}

export default SignupForm;
